export const RESUBMIT_BUDGET = `
  mutation ReSubmitBudget($budgets: Budgets!, $executionId: String!) {
    updateBudget(updateParams: { budgets: $budgets, executionId: $executionId }) {
      element1
      element2
      element3
      element4
      executionId
      requestedBy
      reviewedBy
      status
      year
      budgets {
        _0
        _1
        _2
        _3
        _4
        _5
        _6
        _7
        _8
        _9
        _10
        _11
      }
    }
  }
`
